import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, ViewChild } from '@angular/core';
import type { MenuItem } from 'primeng/api';
import type { Menu } from 'primeng/menu';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-input-split-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './split-button.input.design.html',
    styleUrls: ['./split-button.input.design.scss'],
    standalone: false
})
export class SplitButtonInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() label?: string;
  @Input() tooltipLabel?: string;
  @Input() iconClass?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() iconClassAfter?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input() menuClass: FlatModels.PanelDesignModels.MenuDesignClass = FlatModels.PanelDesignModels.MenuDesignClass.DEFAULT;
  @Input() items: MenuItem[] = [];
	@Output() buttonClick = new EventEmitter<MouseEvent>();
  
  @ViewChild('menu_content', {static: false}) menuElementRef!: Menu;
  
  isOpen = signal(false);
  readonly FlatModels = FlatModels;

  toggle(event: any) {
    this.isOpen.set(!this.isOpen());
    this.menuElementRef.toggle(event)
  }

  hide() {
    this.isOpen.set(false);
  }
}
